<script lang="ts" setup>
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import PageHeader from '@/components/global/page-header/PageHeader.vue'
import SupplierForm from '@/components/features/suppliers/SupplierForm.vue'
import { useRouter } from 'vue-router'
import { useSupplierStore } from '@/stores/supplier-store'
import { useSupplierForm } from '@/composables/useSupplierForm'
import { editSupplier } from '@/api/suppliers'
import { onMounted } from 'vue'
import type { ErrorResponse } from '@/types/error-types'

const supplierStore = useSupplierStore()
const router = useRouter()
const supplierId = router.currentRoute.value.params.id as string

const {
  values,
  addressFields,
  newAddress,
  removeAddress,
  setErrors,
  formType,
  showToast,
  loading,
  handleSubmit,
  meta
} = useSupplierForm('edit')

const onSubmit = handleSubmit(async () => {
  loading.value = true
  const addresses =
    values?.addresses?.map((address: any) => ({
      ...address,
      country: address?.country,
      addressType: address?.addressType?.id
    })) || []

    await editSupplier(
    {
      ...values,
      addresses
    },
    values.id
  )
    .then(() => {
      loading.value = false
      showToast('info', 'Supplier Edited!', 'You have successfully edited supplier.')
      router.push(`/suppliers/${values?.id}`)
    })
        .catch((error: { response?: { data: ErrorResponse } }) => {
          loading.value = false
          const errorMessages = error.response?.data?.errors?.map((err) => err.description).join('\n') || 'Unable to add new supplier.'
          showToast('error', 'An error occurred!', errorMessages)
        })
})

onMounted(async () => {
  supplierStore.categorizeSupplierPricing(supplierId)
})
</script>
<template>
  <PageHeader
    title="Edit Supplier"
    buttonText="Save Changes"
    buttonIcon="material-symbols:save"
    :buttonClick="onSubmit"
    :buttonDisabled="!meta.dirty"
  />

  <TabView class="bg-white rounded-md">
    <TabPanel header="Supplier Details">
      <SupplierForm
        :type="formType"
        :values="values"
        :onSubmit="onSubmit"
        :addressFields="addressFields"
        :newAddress="newAddress"
        :removeAddress="removeAddress"
        :setErrors="setErrors"
        :show-toast="showToast"
      />
    </TabPanel>
  </TabView>
</template>
